export default "__VITE_ASSET__DgWEyYLM__"